import { Outlet } from "react-router-dom";

import PageInfoHeader from "ds/components/PageInfoHeader";

import RunPageWrapper from "../RunPageWrapper";

const RunChangesLayout = () => {
  return (
    <>
      <PageInfoHeader title="Run changes" />
      <RunPageWrapper>
        <Outlet />
      </RunPageWrapper>
    </>
  );
};

export default RunChangesLayout;
